import { Pipe, PipeTransform } from '@angular/core'
import { Worker } from 'src/app/models/worker'
import { Client } from 'src/app/models/client'
import { Contact } from 'src/app/models/contact'

@Pipe({
  name: 'getPrimaryContact',
  standalone: true,
})
export class GetPrimaryContactPipe implements PipeTransform {
  transform(value: Worker | Client, args?: any): any {
    if (value && value.user && value.user.contacts) {
      const contact: Contact = value.user.contacts.find((c) => {
        return c.primary
      })
      if (contact && contact.content) {
        return contact.content
      }
    }
    return null
  }
}
